(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OrderConfigController', OrderConfigController);

    OrderConfigController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', 'UserProfile', 'GlobalValues', '$filter', 'ExposureType', 'ExposureSubType'];

    function OrderConfigController($scope, $rootScope, $state, $uibModalInstance, UserProfile, GlobalValues, $filter, ExposureType, ExposureSubType) {
        var vm = this;
        vm.clear=clear;
        vm.globalValues = GlobalValues;
        vm.save=save;
        $scope.clicked=false;
        loadAll();
        vm.configSettings = vm.globalValues.getConfigSettings();
        vm.noOfDecimalsForAmount = vm.globalValues.getNumberOfDecimalsForAmount();
		vm.noOfDecimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
		vm.noOfdecimalsForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.getCurrencyWiseUserPreference = getCurrencyWiseUserPreference;
        vm.minimumOrderValue = vm.configSettings.minimumOrderValue;
        vm.isAllowStopLoss = vm.configSettings.isAllowStopLossOrder;
        vm.isAllowTakeProfit = vm.configSettings.isAllowTakeProfitOrder;
        vm.isAllowMarketOrder = vm.configSettings.isAllowMarketOrder;
        vm.maximumOrderValueHardCheck = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "MaximumOrderValueHardCheck");
        vm.allowedOrderPriceDeviationFromMarketPriceInPercentage = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
        vm.allowedOrderPriceDeviationFromMarketPriceInPaise = vm.globalValues.getTransactionParameterValue(vm.globalValues.getDefaultCurrencyPairId(), "AllowedOrderPriceDeviationFromMarketPriceInPaise");
        vm.errorText1 = '';
        vm.errorText2 = '';
        vm.errorText3 = '';
        vm.errorText4 = '';
        vm.errorText5 = '';
        vm.exposureType = null;
        vm.exposureSubType = null;
        vm.ExpandOrCollapseUserProfile = false;
        vm.ExpandOrCollapseCurrencyPreferences = false;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function loadAll(){
        	UserProfile.get({
				"userId" : vm.globalValues.getUserId()
			}, onGetUserProfileSuccess, onGetUserProfileError);
        }
        
        function onGetUserProfileSuccess(result){
        	vm.userprofile = result;

            
			updateCurrencyWiseUserPrefrencesForUser(vm.userprofile.currencyWiseUserPreferenceSettingsDTOList);

        	if(vm.userprofile.userPriceCondition=='STLS' && vm.isAllowStopLoss!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
        	if(vm.userprofile.userPriceCondition=='TKPR' && vm.isAllowTakeProfit!='Yes'){
        		vm.userprofile.userPriceCondition = 'LIMT';
        	}
            //load lookup and values for exposure type and exposure sub type
            loadLookupAndValues(vm.userprofile.userExposureType, vm.userprofile.userExposureSubType);
        }


        function updateCurrencyWiseUserPrefrencesForUser(result) {

           $rootScope.currencyWiseUserPreferenceSettings = [];


            angular.forEach(result,function(value){


                
    var currencyId = value.currencyPair.id;
    var shortName = value.shortName;

    if (!currencyId || !shortName) return;

    // Get existing object from map
    var obj = $rootScope.currencyWiseUserPreferenceSettings[currencyId];

    if (!obj) {
        obj = {
            currencyPair: value.currencyPair.code,
            configs: [null, null, null,null] // SPOT, TOM, CASH
        };
    }

    switch (shortName) {
        case "AllowedOrderPriceDeviationFromMarketPriceInPaise":
            obj.configs[0] = value.configValue;
            break;
        case "MaximumOrderValueHardCheck":
            obj.configs[1] = value.configValue;
            break;
        case "MaximumOrderValueSoftCheck":
            obj.configs[2] = value.configValue;
            break;
        case "AllowedOrderPriceDeviationFromMarketPriceInPercentage":
            obj.configs[3] = value.configValue;
            break;    
        default:
            console.warn("Unknown instrumentCode:", shortName);
    }
    
             $rootScope.currencyWiseUserPreferenceSettings[currencyId] =  obj;

            });

        }

        
        //load lookup and values for exposure type and exposure sub type
        function loadLookupAndValues(userExposureType, userExposureSubType){
            loadExposureTypeLookup(userExposureType);
            loadExposureSubTypeLookup(userExposureSubType);
        }
        
        //load lookup and value for exposure type 
        function loadExposureTypeLookup(userExposureType){
            ExposureType.getEnabledExposureTypes(function(result){
                vm.exposureTypes = result;
                angular.forEach(vm.exposureTypes, function(value){
                    if(value.name==userExposureType){
                        vm.exposureType = value;
                    }
                })
                if(vm.exposureType.id==null || vm.exposureType.id==undefined){
                    vm.exposureType = null;
                }
            })
        }
            
        //load lookup and value for exposure sub  type 
        function loadExposureSubTypeLookup(userExposureSubType){
            ExposureSubType.getEnabledExposureSubTypes(function(result){
                vm.exposureSubTypes = result;
                angular.forEach(vm.exposureSubTypes, function(value){
                    if(value.name==userExposureSubType){
                        vm.exposureSubType = value;
                    }
                })
                if(vm.exposureSubType.id==null || vm.exposureSubType.id==undefined){
                    vm.exposureSubType = null;
                }
            })
        }
        vm.validateOrderValue = function validateOrderValue(value){
        	vm.errorText1 = '';
        	if(value!=null && value!=undefined && value!=''){
                var maxHardCheck = vm.maximumOrderValueHardCheck; // Default to min if nothing else
                if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                    maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
                }
        		if(Number(value) < Number(vm.minimumOrderValue) || Number(value) > Number(maxHardCheck)){
        			vm.errorText1 = 'Value should be in between ' + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + ' and ' + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
        		}
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPercentage = function validateAllowedOrderPriceDeviationFromMarketPriceInPercentage(value){
        	vm.errorText2 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPercentage;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPercentage");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText2 = "Value should be less than or equal to Clearcorp's hard check value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPercent) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText2 = "Value should be greater than 0.";
        	}
        }
        
        vm.validateMaximumOrderValueHardCheck = function validateMaximumOrderValueHardCheck(value){
        	vm.errorText3 = '';
            var clearcorpMax = vm.maximumOrderValueHardCheck;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueHardCheck");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(value!=null && value!=undefined && value!=''){
        		if(Number(value) > Number(clearcorpMax)){
        			vm.errorText3 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= Number(vm.minimumOrderValue)){
        			vm.errorText3 = "Value should be greater than Clearcorp's minimum order value " + $filter('number')(vm.minimumOrderValue,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) <= 0){
        			vm.errorText3 = "Value should be greater than 0.";
        		}
        	}
        }
        
        vm.validateMaximumOrderValueSoftCheck = function validateMaximumOrderValueSoftCheck(value){
        	vm.errorText4 = '';
            var clearcorpMax = vm.maximumOrderValueHardCheck;
            var maxHardCheck = clearcorpMax;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "MaximumOrderValueHardCheck");
                if (paramValue != null) {
                    clearcorpMax = paramValue;
                    maxHardCheck = paramValue;
                }
            }
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck) {
                maxHardCheck = vm.currencyWiseUserPreferenceSettings.maximumOrderValueHardCheck;
            }
        	if(value!=null && value!=undefined && value!=''){
		        if(Number(value) > Number(clearcorpMax)){
        			vm.errorText4 = "Value should be less than or equal to Clearcorp's maximum order value hard check " + $filter('number')(clearcorpMax,vm.noOfDecimalsForAmount) + '.';
        		}else if(Number(value) > Number(maxHardCheck)){
		        	vm.errorText4 = "Value should be less than or equal to user level maximum order value hard check " + $filter('number')(maxHardCheck,vm.noOfDecimalsForAmount) + '.';
		        }else if(Number(value) <= 0){
		        	vm.errorText4 = "Value should be greater than 0.";
		        }
        	}
        }
        
        vm.validateAllowedOrderPriceDeviationFromMarketPriceInPaise = function validateAllowedOrderPriceDeviationFromMarketPriceInPaise(value){
        	vm.errorText5 = '';
            var clearcorpMax = vm.allowedOrderPriceDeviationFromMarketPriceInPaise;
            if (vm.currencyWiseUserPreferenceSettings && vm.currencyWiseUserPreferenceSettings.currencyPair) {
                var paramValue = GlobalValues.getTransactionParameterValue(vm.currencyWiseUserPreferenceSettings.currencyPair.id, "AllowedOrderPriceDeviationFromMarketPriceInPaise");
                if (paramValue != null) clearcorpMax = paramValue;
            }
        	if(Number(value) > Number(clearcorpMax)){
        		vm.errorText5 = "Value should be less than or equal to Clearcorp's default value " + $filter('number')(clearcorpMax,vm.noOfDecimalsForPaise) + '.';
        	}else if(Number(value) <= 0){
        		vm.errorText5 = "Value should be greater than 0.";
        	}
        }

        function onGetUserProfileError(){
        	
        }
        
        function save(){
            if(vm.exposureType!=null||vm.exposureType!=undefined ){
                vm.userprofile.userExposureType = vm.exposureType.name;
            }

            if(vm.exposureSubType!=null||vm.exposureSubType!=undefined ){
                vm.userprofile.userExposureSubType = vm.exposureSubType.name;
            }
            
            if(vm.currencyWiseUserPreferenceSettings != undefined && vm.currencyWiseUserPreferenceSettings != null){
			UserProfile.UpdateCurrencyWiseUserPreferenceSettings(vm.currencyWiseUserPreferenceSettings);
			}
			UserProfile.updatePreferences(vm.userprofile, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess(result){
            loadAll();
        	$uibModalInstance.close(result);
        }
        
        function onSaveError(){
        	 $scope.clicked=true;
        }


		function getCurrencyWiseUserPreference(currencyPair){
						UserProfile.getCurrencyWiseUserPreference({"currencyPairId": currencyPair.id,"userId" : vm.globalValues.getUserId()
			},ongetgetCurrencyWiseUserPreferenceSuccess, ongetCurrencyWiseUserPreferenceError);
		}

		function ongetgetCurrencyWiseUserPreferenceSuccess(result){
			vm.currencyWiseUserPreferenceSettings = result;
			vm.clicked=false;
		}

		function ongetCurrencyWiseUserPreferenceError(){
		vm.clicked=false;
		}

    }   
})();
